import React from 'react';
import styled from 'styled-components';
import { Container } from '@ui';
import { FlatButton } from '@ui/buttons';
import { sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import { showErrorBanner } from '@utils/application';
import { useDispatch } from 'react-redux';
import { RFPField } from './RFPEditTool';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const defaultFieldData = [
  //   { name: 'Alternate Questions', value: '' },
  { name: 'Question', value: '' },
  { name: 'Answer_Response', value: '' },

  //   { name: 'Answer_Response 1', value: '' },
  //   { name: 'Answer_Response 2', value: '' },
  //   { name: 'Answer_Response 3', value: '' },
  //   { name: 'Collections', value: '' },
  //   { name: 'Edit Privacy', value: '' },
  //   { name: 'Enable Scheduled Review', value: '' },
  //   { name: 'ID', value: '' },
  //   { name: 'Owners', value: '' },
  //   { name: 'Review cycle', value: '' },
  //   { name: 'Section Name', value: '' },
  //   { name: 'Star Rating', value: '' },
  //   { name: 'Status', value: '' },
  //   { name: 'Used in Projects', value: '' },
  //   { name: 'View Privacy', value: '' },
  //   { name: 'Subscribed To Flag (Yes/No)', value: '' },
];

const updateFieldData = (fieldData, name, value) => {
  const copy = fieldData.map((field) => ({ ...field }));
  const index = copy.findIndex((field) => field.name === name);
  if (index !== -1) {
    copy[index].value = value;
  }
  return copy;
};

function RFPCreateTool({ onCreateComplete }) {
  const dispatch = useDispatch();
  const [fieldData, setFieldData] = React.useState(defaultFieldData);

  const handleSave = async () => {
    console.log('onSave', fieldData);
    const URL = `v1/genai/rfp_responses`;
    const { status, data, error } = await sendApiRequest('POST', URL, { rfp_response: { fields: fieldData } });
    logNetRequest(status, data);
    if (status === 200) {
      return onCreateComplete(data);
    } else {
      showErrorBanner('Something went wrong, please try again.', null, dispatch);
      return false;
    }
  };

  const onFieldChange = (name, value) => {
    setFieldData((prev) => updateFieldData(prev, name, value));
  };

  return (
    <Wrapper>
      {fieldData?.map((field) => (
        <RFPField key={field.name} data={field} onFieldChange={onFieldChange} />
      ))}
      <Container top={48} bottom={24} style={{ textAlign: 'center' }}>
        <FlatButton fullWidth onClick={handleSave}>
          Save
        </FlatButton>
      </Container>
    </Wrapper>
  );
}

export default RFPCreateTool;
